import { render, staticRenderFns } from "./scale-screen.vue?vue&type=template&id=3eabc2af&scoped=true"
import script from "./scale-screen.vue?vue&type=script&lang=js"
export * from "./scale-screen.vue?vue&type=script&lang=js"
import style0 from "./scale-screen.vue?vue&type=style&index=0&id=3eabc2af&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eabc2af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3eabc2af')) {
      api.createRecord('3eabc2af', component.options)
    } else {
      api.reload('3eabc2af', component.options)
    }
    module.hot.accept("./scale-screen.vue?vue&type=template&id=3eabc2af&scoped=true", function () {
      api.rerender('3eabc2af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/scale-screen/scale-screen.vue"
export default component.exports